import { User } from "../model/user/User";
import { ImpersonationKind } from "../model/user/types/ImpersonationKind.enum";
import { AtiraToast } from "./AtiraToast";

export const openImpersonationTab = (
  token: string,
  user: User,
  kind: ImpersonationKind,
  popupBlockedMessage: string,
) => {
  const onMessage = (ev: MessageEvent) => {
    if (ev.source !== w || ev.data?.type !== "IMPERSONATE_READY") {
      return;
    }

    w?.postMessage(
      { type: "IMPERSONATE_TOKEN", token, user, kind },
      window.location.origin,
    );
    window.removeEventListener("message", onMessage);
  };

  window.addEventListener("message", onMessage);

  const w = window.open("/impersonate?imp=1", "_blank");

  if (!w) {
    AtiraToast.error(popupBlockedMessage);
    window.removeEventListener("message", onMessage);
  }
};
